import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";

import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  BaseCustomerPaymentAgingHistoryBean,
  CustomerPaymentAgingHistoryCriteriaBean,
  CustomerSearchCriteria,
  MultiCustomersOnlineAgingPrintRequest,
  MultiCustomersPaymentAgingCriteriaBean,
  PopupAllCustomerCreditMemoDetailsPrintRequest,
  PopupAllCustomerDueDetailsPrintRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  InputRadiobox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCreditMemoModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class AllCustomerAging extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "All Customer Online Aging Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new MultiCustomersPaymentAgingCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      inquiryData: null,
      salesPersons: [],
      isCollapsible_open: true,
      customerData: null,
      salesPersonData: null,
      agingBucketList: [],
      checked: false,
      bucketGroup: null,
      customerDatas: [],
      salesPersonDatas: [],
      allListChecked: true,
      currentAgeAmountChecked: false,
      ageAmount1Checked: false,
      ageAmount2Checked: false,
      ageAmount3Checked: false,
      ageAmount4Checked: false,
      checked: false,
      isShowCustomerModule: false,
      isShowInvoiceModule: false,
      isShowCreditMemoModule: false,
      isShowInvoiceDuePopup: false,
      isShowInvoiceData: false,
      isShowCreditAmountPopup: false,
      isShowCreditAmountData: false,
      agingHistoryBean: new BaseCustomerPaymentAgingHistoryBean(),
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      customerBean: null,
      alertMessage: [],
      isShowAlertLvl1: false,
      isShowAlert: false,
      order: "asc",
      invoiceDetail: new Array(),
      creditMemoDetail: new Array(),
      sortField: "",
      isShowAutoCompleteMasterCustomerList: false,
      masterCustomerPageListForAutoCompleteList: new Array(),
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (!isEmptyArray(attribute_cache.salesPersons)) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handlePopupResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl1: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlertLvl1: true,
      });
      success = true;
    }
    return success;
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  listOnChange = (e) => {
    if (e.target.name === "all") {
      this.setState({
        allListChecked: true,
        currentAgeAmountChecked: false,
        ageAmount1Checked: false,
        ageAmount2Checked: false,
        ageAmount3Checked: false,
        ageAmount4Checked: false,
      });
      this.loadPage(1, 0);
    } else if (e.target.name === "Current") {
      this.setState({
        currentAgeAmountChecked: true,
        allListChecked: false,
        ageAmount1Checked: false,
        ageAmount2Checked: false,
        ageAmount3Checked: false,
        ageAmount4Checked: false,
      });
      this.loadPage(1, 1);
    } else if (e.target.name === "1-30") {
      this.setState({
        ageAmount1Checked: true,
        ageAmount2Checked: false,
        ageAmount3Checked: false,
        ageAmount4Checked: false,
        currentAgeAmountChecked: false,
        allListChecked: false,
      });
      this.loadPage(1, 2);
    } else if (e.target.name === "31-60") {
      this.setState({
        ageAmount2Checked: true,
        ageAmount1Checked: false,
        ageAmount3Checked: false,
        ageAmount4Checked: false,
        currentAgeAmountChecked: false,
        allListChecked: false,
      });
      this.loadPage(1, 3);
    } else if (e.target.name === "61-90") {
      this.setState({
        ageAmount3Checked: true,
        ageAmount2Checked: false,
        ageAmount1Checked: false,
        ageAmount4Checked: false,
        currentAgeAmountChecked: false,
        allListChecked: false,
      });
      this.loadPage(1, 4);
    } else if (e.target.name === "91+") {
      this.setState({
        ageAmount4Checked: true,
        ageAmount3Checked: false,
        ageAmount2Checked: false,
        ageAmount1Checked: false,
        currentAgeAmountChecked: false,
        allListChecked: false,
      });
      this.loadPage(1, 5);
    }
  };

  /********************Master Customer *************************/

  masterCustomerCodeOnChange = (e) => {
    let masterCustomerCode = e.target.value;
    this.state.isShowAutoCompleteMasterCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteMasterCustomerList;
    if (isEmpty(masterCustomerCode)) {
      this.state.isShowAutoCompleteMasterCustomerList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteMasterCustomerList;
      let criteria = this.state.criteria;
      criteria.masterCustomerCode = "";

      let suggestion = [];
      let customerBean = null;
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        masterCustomerPageListForAutoCompleteList: suggestion,
        customerData: customerBean,
      });
    } else if (
      e.target.name == "masterCustomerCode" &&
      showAutoCompleteList === true &&
      masterCustomerCode !== ""
    ) {
      this.readMasterCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };

  readMasterCustomer = (masterCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = masterCustomerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.readCustomer(
      readrestInput,
      this.editMasterCustomerResponse,
      this.errorCallBack
    );
  };
  editMasterCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.masterCustomerCode = customerData.code;
      this.setState({ customerData: customerData });
    }
  };
  readMasterCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    searchCriteria.isMasterCustomer = true;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readBymasterCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readBymasterCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      let customerData = response.data.customerPageList.customers;

      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        masterCustomerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  masterCustomerCodeEnterKeyEventHandler = (e) => {
    let masterCustomerCode = e.target.value;
    this.readMasterCustomer(masterCustomerCode);
    this.setState({
      masterCustomerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteMasterCustomerList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteMasterCustomerList: showAutoCompleteList,
    });
  };

  /************************Customer ***************************/

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      let customerBean = null;
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
        customerData: customerBean,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.readCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };
  editCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      this.setState({ customerData: customerData });
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      let customerData = response.data.customerPageList.customers;

      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  loadPage = (pageNumber, option) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.agingDisplayOptionValue = option;
    this.setState({ criteria: criteria });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadAllCustomerOnlineAgingInquiryList(criteria);
    this.hideAlertCallBack(false);
  };
  loadAllCustomerOnlineAgingInquiryList = (criteria) => {

    if (SecurityAccessManager.AllCustomerOnlineAgingInquiry_IsAccessible()) {
      ReportService.inquireMultiCustomersOnlineAging(
        criteria,
        this.loadAllCustomerOnlineAgingPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadAllCustomerOnlineAgingPageResponse = (response) => {

    this.showErrorMessage(response.data);
    if (response.data != null) {
      let inquiryList = response.data.onLineAgingResult;
      let agingBucketList = [];
      let agingDataList = [];
      if (inquiryList != null) {
        const bucketGroup = inquiryList.agingBucketGroupBean;
        if (bucketGroup != null) {
          if (
            !isEmptyArray(bucketGroup.buckets) &&
            bucketGroup.buckets != null
          ) {
            agingBucketList = inquiryList.agingBucketGroupBean.buckets;
          }
        }
        if (!isEmptyArray(inquiryList.agingInfos)) {
          agingDataList = inquiryList.agingInfos;
          this.setState({
            isShowPDFButton: true,
            isShowExcelButton: true,
          });
        }
        this.setState({
          isInquiryDatasFound: true,
          isShowResetButton: true,
          inquiryDataList: agingDataList,
          inquiryData: inquiryList,
          agingBucketList: agingBucketList,
          bucketGroup: bucketGroup,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          isCollapsible_open: false,
          isShowClearCriteriaButton: false,
        });
        this.disable();
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new MultiCustomersOnlineAgingPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateMultiCustomersOnlineAgingPrintReport(
          listRequest,
          this.generateAllCustomerOnlineAgingPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateMultiCustomersOnlineAgingPrintReport(
          listRequest,
          this.generateAllCustomerOnlineAgingPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateAllCustomerOnlineAgingPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

    generateAllCustomerOnlineAgingPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
           let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1, 0);
    this.setState({
      isCollapsible_open: false,
      allListChecked: true,
      currentAgeAmountChecked: false,
      ageAmount1Checked: false,
      ageAmount2Checked: false,
      ageAmount3Checked: false,
      ageAmount4Checked: false,
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new MultiCustomersPaymentAgingCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.salesPersonCode = "";
    this.setState({
      criteria: criteria,
      isCollapsible_open: true,
      salesPersonDatas: [],
      customerDatas: [],
      customerData: null,
      salesPersonData: null,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new MultiCustomersPaymentAgingCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.salesPersonCode = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isCollapsible_open: true,
      salesPersonDatas: [],
      customerDatas: [],
      customerData: null,
      salesPersonData: null,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isCollapsible_open: true,
      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  deleteCustomer = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.customerCodes;
    let customerDatas = this.state.customerDatas;
    customerDatas.map((list, index) => {
      if (list.code == line.code) {
        lineData.splice(index, 1);
        customerDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, customerData: null });
  };
  addCustomer = () => {
    let criteria = this.state.criteria;
    criteria.customerCode = "";
    let customerData = this.state.customerData;
    let customerDatas = this.state.customerDatas;
    if (customerData != null) {
      if (!isEmptyArray(customerDatas)) {
        let exists = customerDatas.find((p) => p.code === customerData.code);
        if (!exists) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      } else {
        if (!isEmptyString(customerData.code)) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      }
    }
  };
  deleteSalesPerson = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.salesPersonCodes;
    let salesPersonDatas = this.state.salesPersonDatas;
    salesPersonDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        salesPersonDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, salesPersonData: null });
  };
  addSalesPerson = () => {
    let criteria = this.state.criteria;
    criteria.salesPersonCode = "";
    let salesPersonData = this.state.salesPersonData;
    let salesPersonDatas = this.state.salesPersonDatas;
    if (salesPersonData != null) {
      if (!isEmptyArray(salesPersonDatas)) {
        let exists = salesPersonDatas.find(
          (p) => p.code === salesPersonData.code
        );
        if (!exists) {
          salesPersonDatas.push(salesPersonData);
          criteria.salesPersonCodes.push(salesPersonData.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonData: null,
          });
        }
      } else {
        if (!isEmptyString(salesPersonData.code)) {
          salesPersonDatas.push(salesPersonData);
          criteria.salesPersonCodes.push(salesPersonData.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonData: null,
          });
        }
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
      isShowAlertLvl1: false,
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceDuePopup = (e, val, rowData) => {
    if (e.detail === 1) {
      this.loadInvoiceDetailList(rowData.customerCode);
      this.setState({
        invoiceData: rowData,
        isShowInvoiceData: true,
        isShowInvoiceDuePopup: true,
      });
    }
  };

  viewCreditAmountPopup = (e, val, rowData) => {
    if (e.detail === 1) {
      this.loadInvoiceDetailList(rowData.customerCode);
      this.setState({
        creditData: rowData,
        isShowCreditAmountData: true,
        isShowCreditAmountPopup: true,
      });
    }
  };
  loadInvoiceDetailList = (code) => {
    let criteriaBean = new CustomerPaymentAgingHistoryCriteriaBean();
    criteriaBean.companyCode = this.companyCode;
    criteriaBean.customerCode = code;

    if (SecurityAccessManager.AllCustomerOnlineAgingInquiry_IsAccessible()) {
      ReportService.inquireCustomerPaymentCurrentAgingHistory(
        criteriaBean,
        this.loadInvoiceDetailResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadInvoiceDetailResponse = (response) => {
    this.showErrorMessage(response.data);
    let invoiceDetail = [];
    let creditMemoDetail = [];
    if (response.data != null && response.data.result != null) {
      const agingHistory = response.data.result.agingHistoryBean;
      invoiceDetail = agingHistory.invoiceDetails;
      creditMemoDetail = agingHistory.creditMemoDetails;
      if (agingHistory != null) {
        this.setState({
          agingHistoryBean: agingHistory,
          invoiceDetail: invoiceDetail,
          creditMemoDetail: creditMemoDetail,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowInvoiceDuePopup: isShowPopup,
      isShowCreditAmountPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowCreditAmountPopup: false,
      isShowInvoiceData: false,
      isShowAlertLvl1: isShowPopup,
    });
  };
  generateInvoicePdfReport = (e) => {
    if (e.detail === 1) this.genearteInvoiceReport(1);
  };
  generateInvoiceExcelReport = (e) => {
    if (e.detail === 1) this.genearteInvoiceReport(2);
  };
  genearteInvoiceReport = (reportType) => {
    let invoiceData = this.state.invoiceData;
    let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = invoiceData.customerCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PopupAllCustomerDueDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generatePopupAllCustomerDueDetailsPrintReport(
          listRequest,
          this.generateInvoicePageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generatePopupAllCustomerDueDetailsPrintReport(
          listRequest,
          this.generateInvoicePageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateInvoicePageResponse = (response) => {
    this.handlePopupResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlertLvl1: false,
    });
  };
    generateInvoicePageResponseForExcel = (response) => {
    this.handlePopupResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
           let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlertLvl1: false,
    });
  };

  generateMemoPdfReport = (e) => {
    if (e.detail === 1) this.genearteMemoReport(1);
  };
  generateMemoExcelReport = (e) => {
    if (e.detail === 1) this.genearteMemoReport(2);
  };
  genearteMemoReport = (reportType) => {
    let creditData = this.state.creditData;
    let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = creditData.customerCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PopupAllCustomerCreditMemoDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryPDFReport_IsAccessible
      ) {
        ReportService.generatePopupAllCustomerCreditMemoDetailsPrintReport(
          listRequest,
          this.generateMemoPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.AllCustomerOnlineAgingInquiryExcelReport_IsAccessible
      ) {
        ReportService.generatePopupAllCustomerCreditMemoDetailsPrintReport(
          listRequest,
          this.generateMemoPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    }
  };
  generateMemoPageResponse = (response) => {
    this.handlePopupResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateMemoPageResponseForExcel = (response) => {
    this.handlePopupResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonData: salesPersonBean });
  };

  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      let suggestion = [];
      let salesPersonData = null;
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
        salesPersonData: salesPersonData,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readSalesPerson(salesPersonCode);
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };

  RattingvalueHandler = (col, row, rate) => {
    if (rate === 1) {
      return "bg-yellow";
    } else if (rate === 2) {
      return "bg-pink";
    } else if (rate >= 3) {
      return "bg-red";
    } else {
      return "bg-green";
    }
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerCode", "customerCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson#", "salesPersonCodes", true)

        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalDue", "totalInvoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceDuePopup, null)
        .setSubHeaderDetails(true, "allCustomerTotalInvoiceDueAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PH#", "phone1", true)

        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Rating", "rating", true)
        .setGraphDetails(true, this.RattingvalueHandler)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LastPayDate", "lastPaymentDate", true)

        .setStyleDetails("left", "10", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LastPayAmt", "lastPaymentAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CurrentAgeAmt", "currentAgeAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerCurrentAgeAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("1-30", "ageAmount1", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount1")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("31-60", "ageAmount2", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("61-90", "ageAmount3", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("90+", "ageAmount4", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "UnAppliedCredit",
          "totalUnAppliedCreditMemoAmount",
          true,
          true
        )
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewCreditAmountPopup, null)
        .setSubHeaderDetails(true, "allCustomerTotalCreditMemoAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ProvPaid", "totalProvisionalAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerProvisionalAppliedAmount")
        
       // .setClickDetails(true, false, this.viewCustomerProvisionalPopup, null)
    );
    return columns;
  };
  creditMemoDetailColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "creditMemoNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt", "creditMemoTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "apppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UnAppliedAmt", "unAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  openInvoicesDetailColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson#", "salesPersonCodes", true)

        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPersonName", "salesPersonNames", true)

        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceAmt", "invoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueDate", "invoicePaymentDueDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueAmt", "invoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ProvPaid", "invoiceProvisionalPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalDue", "invoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let agingBucketList = this.state.agingBucketList;
    let summaryDetail = this.state.inquiryData;
    let invoiceData = this.state.invoiceData;
    let creditData = this.state.creditData;
    let agingHistoryBean = this.state.agingHistoryBean;
    let invoiceDetail = this.state.invoiceDetail;
    let creditMemoDetail = this.state.creditMemoDetail;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          execute={this.execute}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          addCustomer={this.addCustomer}
          addSalesPerson={this.addSalesPerson}
          showHideSecondHeader={this.showHideSecondHeader}
          deleteCustomer={this.deleteCustomer}
          deleteSalesPerson={this.deleteSalesPerson}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          masterCustomerCodeOnChange={this.masterCustomerCodeOnChange}
          masterCustomerCodeEnterKeyEventHandler={
            this.masterCustomerCodeEnterKeyEventHandler
          }
          displayAutoCompleteMasterCustomerList={
            this.displayAutoCompleteMasterCustomerList
          }
        />
        {/* {this.state.isInquiryDatasFound && (
          <div>
            <Row>
              <FormLabel>Display Options</FormLabel>
            </Row>
            <Row>
              <Col md={1}>
                <FormLabel>All </FormLabel>
              </Col>
              <Col md={0.9}>
                <InputRadiobox
                  name="all"
                  checked={this.state.allListChecked}
                  onChange={this.listOnChange}
                />
              </Col>
              {agingBucketList.map((list, index) => (
                <div>
                  <Col>
                    <FormLabel>{list.code} </FormLabel>
                  </Col>
                  <Col sm="4">
                    {list.code === "Current" && (
                      <InputRadiobox
                        name={list.code}
                        checked={this.state.currentAgeAmountChecked}
                        onChange={this.listOnChange}
                      />
                    )}
                    {list.code === "1-30" && (
                      <InputRadiobox
                        name={list.code}
                        checked={this.state.ageAmount1Checked}
                        onChange={this.listOnChange}
                      />
                    )}
                    {list.code === "31-60" && (
                      <InputRadiobox
                        name={list.code}
                        checked={this.state.ageAmount2Checked}
                        onChange={this.listOnChange}
                      />
                    )}
                    {list.code === "61-90" && (
                      <InputRadiobox
                        name={list.code}
                        checked={this.state.ageAmount3Checked}
                        onChange={this.listOnChange}
                      />
                    )}
                    {list.code === "91+" && (
                      <InputRadiobox
                        name={list.code}
                        checked={this.state.ageAmount4Checked}
                        onChange={this.listOnChange}
                      />
                    )}
                  </Col>
                </div>
              ))}
            </Row> */}
   {this.state.isInquiryDatasFound && (
          <div>
          <div className="aging-container">
  <div className="aging-header">Display Options</div>

  <div className="aging-grid">
    {/* ALL OPTION */}
    <div className="aging-item">
      <span className="aging-label">All</span>
      <InputRadiobox
        name="all"
        checked={this.state.allListChecked}
        onChange={this.listOnChange}
      />
    </div>

    {/* DYNAMIC LIST */}
    {agingBucketList.map((list, index) => {
      let checkedValue = false;

      if (list.code === "Current") checkedValue = this.state.currentAgeAmountChecked;
      if (list.code === "1-30") checkedValue = this.state.ageAmount1Checked;
      if (list.code === "31-60") checkedValue = this.state.ageAmount2Checked;
      if (list.code === "61-90") checkedValue = this.state.ageAmount3Checked;
      if (list.code === "91+") checkedValue = this.state.ageAmount4Checked;

      return (
        <div key={index} className="aging-item">
          <span className="aging-label">{list.code}</span>
          <InputRadiobox
            name={list.code}
            checked={checkedValue}
            onChange={this.listOnChange}
          />
        </div>
      );
    })}
  </div>
</div>
            
            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryColumns()}
                subHeaderData={summaryDetail}
                label={"Inquiry Data List"}
                enableVritualizer={true}
              />
            </div>
            {/* <SimplePopup */}
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowInvoiceDuePopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel2"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Open Invoices"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              headerButtonContainer={
                <div className="floatLeft">
                  {this.state.isShowInvoiceData && (
                    <div>
                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.generateInvoicePdfReport(e)}
                      >
                        PDF
                      </Button>

                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.generateInvoiceExcelReport(e)}
                      >
                        EXCEL
                      </Button>
                    </div>
                  )}
                </div>
              }
              content={
                <div className="">
                  {this.state.isShowInvoiceData && (
                    <div>
                      <Row>
                        <Col sm="1">
                          <FormLabel>CompanyCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={invoiceData.companyCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="1">
                          <FormLabel>CustomerCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={invoiceData.customerCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="5">
                          <InputTextbox
                            value={invoiceData.customerName}
                            disabled={true}
                          />{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col sm="1">
                          <FormLabel>CurrencyCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={invoiceData.currencyCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="1">
                          {" "}
                          <FormLabel>Total Due</FormLabel>
                        </Col>
                        <Col className="summary_text_box" sm="2">
                          <InputTextbox
                            value={toCommaSeperatedAmount(
                              invoiceData.totalInvoiceDueAmount
                            )}
                            className="summary_input text-right"
                            disabled={true}
                          />
                        </Col>
                      </Row>
                      <div>
                        <div className="mt-3">
                          <CustomTable
                            data={invoiceDetail}
                            columns={this.openInvoicesDetailColumns()}
                            label={"Open Invoices Data List"}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              }
            />
            {/* <SimplePopup */}
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowCreditAmountPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel2"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Open CreditMemos"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              headerButtonContainer={
                <div className="floatLeft">
                  {this.state.isShowCreditAmountData && (
                    <div>
                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.generateMemoPdfReport(e)}
                      >
                        PDF
                      </Button>

                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.generateMemoExcelReport(e)}
                      >
                        EXCEL
                      </Button>
                    </div>
                  )}
                </div>
              }
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.state.alertMessage}
                  alertErrorType={this.state.alertType}
                  isShowAlert={this.state.isShowAlertLvl1}
                  hideAlertCallBack={this.hideAlertCallBack}
                />
              }
              content={
                <div className="">
                  {this.state.isShowCreditAmountData && (
                    <div>
                      <Row>
                        <Col sm="1">
                          <FormLabel>CompanyCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={creditData.companyCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="1">
                          <FormLabel>CustomerCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={creditData.customerCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="5">
                          <InputTextbox
                            value={creditData.customerName}
                            disabled={true}
                          />{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col sm="1">
                          <FormLabel>CurrencyCode</FormLabel>
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            value={creditData.currencyCode}
                            disabled={true}
                          />{" "}
                        </Col>

                        <Col sm="1">
                          {" "}
                          <FormLabel>Total Due</FormLabel>
                        </Col>
                        <Col className="summary_text_box" sm="2">
                          <InputTextbox
                            value={creditData.totalUnAppliedCreditMemoAmount}
                            className="summary_input text-right"
                            disabled={true}
                          />
                        </Col>
                      </Row>
                      <div>
                        <div className="mt-3">
                          <CustomTable
                            data={creditMemoDetail}
                            columns={this.creditMemoDetailColumns()}
                            label={"CreditMemo Details Data List"}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              }
            />
          </div>
        )}
        {/* <ModulePopup */}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />

        
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
      customerList: this.props.customerList,
      isCollapsible_open: this.props.isCollapsible_open,
    };
    this.customerCodeRef = React.createRef();
    this.salesPersonCodeRef = React.createRef();
    // this.masterCustomerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  loadPage = () => {
    this.props.execute(1);
  };
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let masterCustomerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
      false,
      true
    );
    this.setState({ masterCustomerLookupHandler: masterCustomerLookupHandler });

    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  deleteCustomer = (e, val, rowData) => {
    this.props.deleteCustomer(rowData);
  };
  deleteSalesPerson = (e, val, rowData) => {
    this.props.deleteSalesPerson(rowData);
  };
  customerColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition().setDetails("CustomerCode#", "code", true)
    );
    columns.push(
      new ColumnDefinition().setDetails("Name", "description", true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Remove", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteCustomer, <DeleteIcon />)
    );

    return columns;
  };
  salesPersonColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson#", "code", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "description", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteSalesPerson, <DeleteIcon />)
    );

    return columns;
  };

  addCustomer = (e) => {
    if (e.detail === 1) {
      this.props.addCustomer();
      if (this.customerCodeRef.current != null) {
        this.customerCodeRef.current.clear();
        this.customerCodeRef.current.focus();
      }
    }
  };
  addSalesPerson = (e) => {
    if (e.detail === 1) {
      this.props.addSalesPerson();
      this.salesPersonCodeRef.current.clear();
      this.salesPersonCodeRef.current.focus();
    }
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  masterCustomerCodeOnChange = (e) => {
    this.props.masterCustomerCodeOnChange(e);
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  masterCustomerCodeEnterKeyEventHandler = (e) => {
    this.props.masterCustomerCodeEnterKeyEventHandler(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };
  displayAutoCompleteMasterCustomerList = () => {
    this.props.displayAutoCompleteMasterCustomerList();
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };

  render() {
    let criteria = this.props.criteria;
    let customerDatas = this.props.customerDatas;
    let salesPersonDatas = this.props.salesPersonDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.customerCodeRef}
              name="customerCode"
              onChange={this.customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addCustomer(e)}
              disabled={isDisableFields}
            >
              Add
            </Button>
          </Col>

          <Col sm="1">
            <FormLabel>SalesPerson</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.salesPersonCodeRef}
              name="salesPersonCode"
              onChange={this.salesPersonCodeOnChange}
              value={criteria.salesPersonCode}
              lookupRequired={true}
              lookupHandler={this.state.salesPersonLookupHandler}
              enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
              autoCompleteListData={
                this.props.salesPersonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteSalesPersonList}
              showAutoCompleteList={this.props.showAutoCompleteSalesPersonList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addSalesPerson(e)}
              disabled={isDisableFields}
            >
              Add
            </Button>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>MasterCustomer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              // ref={this.masterCustomerCodeRef}
              name="masterCustomerCode"
              onChange={this.masterCustomerCodeOnChange}
              value={criteria.masterCustomerCode}
              lookupRequired={true}
              lookupHandler={this.state.masterCustomerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.masterCustomerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.masterCustomerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayAutoCompleteMasterCustomerList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteMasterCustomerList
              }
              disabled={isDisableFields}
            />
          </Col>
          {/* <Col sm="2">
            <Button
              className="header_buttons  enterFocus"
              size="sm"
              onClick={this.loadPage}
              disabled={isDisableFields}
            >
              {" "}
              <PlayIcon />
              {""}EXEC{" "}
            </Button>
          </Col> */}
          <Col >
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="4">
              <CustomTable
                data={customerDatas}
                columns={this.customerColumnDefinitions()}
                label={"Customer Data List"}
              />
            </Col>

            <Col sm="4">
              <CustomTable
                data={salesPersonDatas}
                columns={this.salesPersonColumnDefinitions()}
                label={"SalesPerson Data List"}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

function AllCustomerOnlineAgingInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <AllCustomerAging {...props} name="" /> <br />
    </div>
  );
}

export default AllCustomerOnlineAgingInquiry;
